var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"disabled":_vm.disabled,"top":_vm.top,"right":_vm.right,"left":_vm.left,"bottom":_vm.bottom},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({},'span',attrs,false),Object.assign({}, tooltip)),[_vm._t("default")],2)]}}],null,true)},[_c('span',{staticClass:"text-caption"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }